<script>

import request from '@/services/request'
import { mapActions } from 'vuex';
import Catalogue from '@/services/catalogue';

export default {

    data() {

        return {

            catalogue: new Catalogue(),

            load: false,
            send: false,
            errors: {},

            extraDue: {

                id: '',

                user_id: '',

                company_id: null,

                billing_data_id: null,

                due_date: '',

                description: '',

                currency_id: 1,

                exchange_rate_pay: ''

            },

            services: []

        }

    },


    computed: {

        /*
         * Resumen general de todos los conceptos
         */
        totals() {

            return this.services.reduce((result, service) => {

                const values = this.calculateService(service);

                const sign = service.negative == 1
                    ? -1
                    : 1;

                result.subtotal += values.subtotal * sign;

                result.iva += values.iva * sign;

                result.ieps += values.ieps * sign;

                result.isrRet += values.isrRet * sign;

                result.ivaRet += values.ivaRet * sign;

                result.total += values.total * sign;

                return result;

            }, {

                subtotal: 0,

                iva: 0,

                ieps: 0,

                isrRet: 0,

                ivaRet: 0,

                total: 0

            });

        },


        totalAmount() {

            return this.totals.total;

        }

    },


    methods: {

        /*
         * ========================================
         * DATOS DE FACTURACIÓN
         * ========================================
         */
        async loadBillingData(reset = true) {

            if (reset) {

                this.extraDue.billing_data_id = null;

            }

            if (!this.extraDue.user_id) {

                this.catalogue.billing_data_user = [];

                return;

            }

            await this.catalogue.getBillingDataUser(
                this.extraDue.user_id
            );

        },


        /*
         * ========================================
         * FECHA
         * ========================================
         */
        getCurrentDate() {

            const date = new Date();

            const year =
                date.getFullYear();

            const month =
                String(
                    date.getMonth() + 1
                ).padStart(2, '0');

            const day =
                String(
                    date.getDate()
                ).padStart(2, '0');

            return `${year}-${month}-${day}`;

        },


        /*
         * ========================================
         * RESET
         * ========================================
         */
        resetForm() {

            this.errors = {};

            this.send = false;

            this.load = false;

            this.extraDue = {

                id: '',

                user_id: '',

                company_id: null,

                billing_data_id: null,

                due_date: this.getCurrentDate(),

                description: '',

                currency_id: 1,

                exchange_rate_pay: ''

            };

            this.services = [];

        },


        /*
         * ========================================
         * CONCEPTOS
         * ========================================
         */
        addService() {

            this.services.push({

                id: '',

                service_id: null,

                description: '',

                base_amount: 0,

                final_amount: 0,

                negative: 0,

                // Impuestos
                iva: 0,

                ieps: 0,

                isr_ret: 0,

                iva_ret: 0

            });

        },


        deleteService(index) {

            if (this.services.length <= 1) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'El adeudo debe tener al menos un concepto.'

                        }

                    }

                });

                return;

            }


            this.services.splice(
                index,
                1
            );

        },


        /*
         * ========================================
         * CÁLCULO DE UN CONCEPTO
         * ========================================
         */
        calculateService(service) {

            const subtotal =
                parseFloat(
                    service.base_amount || 0
                );


            const iva =
                service.iva
                    ? subtotal * 0.16
                    : 0;


            const ieps =
                service.ieps
                    ? subtotal * 0.08
                    : 0;


            const isrRet =
                service.isr_ret
                    ? subtotal * 0.10
                    : 0;


            const ivaRet =
                service.iva_ret
                    ? subtotal * 0.106666
                    : 0;


            const total =
                subtotal
                + iva
                + ieps
                - isrRet
                - ivaRet;


            return {

                subtotal,

                iva,

                ieps,

                isrRet,

                ivaRet,

                total

            };

        },


        /*
         * ========================================
         * MODAL
         * ========================================
         */
        closedModal() {

            this.resetForm();

            this.$modal.hide(
                'ExtraDueWithoutContract'
            );

        },


        openCreate() {

            this.resetForm();

            this.addService();

            this.$modal.show(
                'ExtraDueWithoutContract'
            );

        },


        /*
         * ========================================
         * EDITAR
         * ========================================
         */
        async openEdit(id) {

            this.resetForm();

            this.load = true;

            this.$modal.show(
                'ExtraDueWithoutContract'
            );


            try {

                let { data } =
                    await request.get(
                        '/extra_dues/' + id
                    );


                this.extraDue = {

                    id:
                        data.id,

                    user_id:
                        data.user_id,

                    company_id:
                        data.company_id,

                    billing_data_id:
                        data.billing_data_id,

                    due_date:
                        data.due_date
                            ? data.due_date.substring(0, 10)
                            : '',

                    description:
                        data.description,

                    currency_id:
                        data.currency_id,

                    exchange_rate_pay:
                        parseFloat(
                            data.exchange_rate_pay || 0
                        )

                };


                /*
                 * Cargar datos fiscales
                 * sin limpiar billing_data_id
                 */
                await this.loadBillingData(false);


                /*
                 * Cargar conceptos
                 */
                this.services =
                    (data.items || []).map(item => {

                        return {

                            id:
                                item.id,

                            service_id:
                                item.service_id,

                            description:
                                item.description,

                            base_amount:
                                parseFloat(
                                    item.base_amount || 0
                                ),

                            final_amount:
                                parseFloat(
                                    item.final_amount || 0
                                ),

                            negative:
                                item.negative
                                    ? 1
                                    : 0,

                            iva:
                                item.iva
                                    ? 1
                                    : 0,

                            ieps:
                                item.ieps
                                    ? 1
                                    : 0,

                            isr_ret:
                                item.isr_ret
                                    ? 1
                                    : 0,

                            iva_ret:
                                item.iva_ret
                                    ? 1
                                    : 0

                        };

                    });


                if (
                    this.services.length === 0
                ) {

                    this.addService();

                }


            } catch (error) {

                this.errors =
                    await this.errorNotification(error);

                this.closedModal();

            }


            this.load = false;

        },


        /*
         * ========================================
         * VALIDACIONES
         * ========================================
         */
        validateForm() {

            if (!this.extraDue.company_id) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'Selecciona una compañía.'

                        }

                    }

                });

                return false;

            }


            if (!this.extraDue.user_id) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'Selecciona un cliente.'

                        }

                    }

                });

                return false;

            }


            if (!this.extraDue.due_date) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'Selecciona una fecha.'

                        }

                    }

                });

                return false;

            }


            if (
                this.extraDue.currency_id == 2 &&
                parseFloat(
                    this.extraDue.exchange_rate_pay || 0
                ) <= 0
            ) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'Captura el tipo de cambio.'

                        }

                    }

                });

                return false;

            }


            if (
                this.services.length === 0
            ) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'Agrega al menos un concepto.'

                        }

                    }

                });

                return false;

            }


            let invalidService =
                this.services.find(service => {

                    return (

                        !service.description ||

                        parseFloat(
                            service.base_amount || 0
                        ) <= 0

                    );

                });


            if (invalidService) {

                this.errorNotification({

                    response: {

                        data: {

                            message:
                                'Todos los conceptos deben tener descripción y un monto mayor a cero.'

                        }

                    }

                });

                return false;

            }


            return true;

        },


        /*
         * ========================================
         * GUARDAR
         * ========================================
         */
        async saveAll() {

            if (!this.validateForm()) {

                return;

            }


            this.send = true;

            this.errors = {};


            let dataForm = {

                user_id:
                    this.extraDue.user_id,

                company_id:
                    this.extraDue.company_id,

                billing_data_id:
                    this.extraDue.billing_data_id,

                due_date:
                    this.extraDue.due_date,

                description:
                    this.extraDue.description,

                currency_id:
                    this.extraDue.currency_id,

                exchange_rate_pay:
                    this.extraDue.currency_id == 2
                        ? this.extraDue.exchange_rate_pay
                        : null,

                services:
                    this.services.map(service => {

                        const totals =
                            this.calculateService(service);


                        return {

                            id:
                                service.id,

                            service_id:
                                service.service_id,

                            description:
                                service.description,

                            base_amount:
                                service.base_amount,

                            /*
                             * El backend debe volver
                             * a calcular este valor.
                             *
                             * Lo mandamos como referencia.
                             */
                            final_amount:
                                totals.total,

                            negative:
                                service.negative,

                            iva:
                                service.iva
                                    ? 1
                                    : 0,

                            ieps:
                                service.ieps
                                    ? 1
                                    : 0,

                            isr_ret:
                                service.isr_ret
                                    ? 1
                                    : 0,

                            iva_ret:
                                service.iva_ret
                                    ? 1
                                    : 0

                        };

                    })

            };


            try {

                let _endpoint = '/extra_dues';

                if (this.extraDue.id) {
                    _endpoint = `/extra_dues/${this.extraDue.id}`;
                    dataForm._method = 'PUT';                   
                }

                let {data}  = await request.post(
                    _endpoint,
                    dataForm
                );

                this.successNotification(
                    data.message
                );

                Event.$emit(
                    'event-load-extra-dues-without-contract'
                );

                this.closedModal();
            
            } catch (error) {

                this.errors =
                    await this.errorNotification(error);

            }


            this.send = false;

        },


        ...mapActions({

            errorNotification:
                'alert/error',

            successNotification:
                'alert/success',

        }),

    },


    mounted() {

        this.catalogue.get_users_profile(7);

        this.catalogue.get_companies_all();

        this.catalogue.getCurrencies();

    },


    created() {

        Event.$on(
            'event-create-extra-due-without-contract',
            () => {

                this.openCreate();

            }
        );


        Event.$on(
            'event-edit-extra-due-without-contract',
            (id) => {

                this.openEdit(id);

            }
        );

    }

}

</script>


<template>

    <modal
        name="ExtraDueWithoutContract"
        :width="'96%'"
        :height="'92%'"
        :scrollable="false"
        :adaptive="true"
        v-bind:click-to-close="false"
    >

        <div class="extra-due-modal">

            <!-- ================================
                 HEADER
            ================================= -->

            <div class="extra-modal-header">

                <div class="header-icon">
                    <i class="fas fa-file-invoice-dollar"></i>
                </div>

                <div class="header-content">

                    <h5>
                        {{
                            extraDue.id
                                ? 'Editar adeudo extra'
                                : 'Nuevo adeudo extra'
                        }}
                    </h5>

                    <small>
                        Registra un cargo extraordinario
                        sin contrato asociado.
                    </small>

                </div>

                <button
                    type="button"
                    class="header-close"
                    @click="closedModal()"
                >
                    <i class="fas fa-times"></i>
                </button>

            </div>


            <!-- ================================
                 LOADING
            ================================= -->

            <div
                class="loading-container"
                v-if="load"
            >

                <i
                    class="fas fa-circle-notch fa-spin fa-3x"
                ></i>

                <div>
                    Cargando información...
                </div>

            </div>


            <!-- ================================
                 CONTENIDO
            ================================= -->

            <div
                class="extra-modal-content"
                v-else
            >

                <!-- CONTENIDO IZQUIERDO -->

                <div class="extra-main">


                    <!-- ================================
                         PASO 1
                    ================================= -->

                    <div class="section-card">

                        <div class="section-heading">

                            <div class="step-number">
                                1
                            </div>

                            <div>

                                <h6>
                                    Datos del adeudo
                                </h6>

                                <small>
                                    Selecciona la compañía, cliente,
                                    fecha y moneda del movimiento.
                                </small>

                            </div>

                        </div>


                        <div class="section-body">

                            <div class="row">


                                <!-- COMPAÑÍA -->

                                <div class="col-lg-4 col-md-6 mb-3">

                                    <label class="field-label">

                                        Compañía

                                        <span class="required">
                                            *
                                        </span>

                                    </label>

                                    <select
                                        class="form-control"
                                        v-model="extraDue.company_id"
                                    >

                                        <option value="">
                                            Selecciona una compañía
                                        </option>

                                        <option
                                            :value="company.id"
                                            v-for="(company, index)
                                                in catalogue.companies_all"
                                            :key="index"
                                        >
                                            {{ company.name }}
                                        </option>

                                    </select>

                                </div>


                                <!-- CLIENTE -->

                                <div class="col-lg-4 col-md-6 mb-3">

                                    <label class="field-label">

                                        Cliente

                                        <span class="required">
                                            *
                                        </span>

                                    </label>

                                    <select
                                        class="form-control"
                                        v-model="extraDue.user_id"
                                        @change="loadBillingData(true)"
                                    >

                                        <option value="">
                                            Selecciona un cliente
                                        </option>

                                        <option
                                            :value="user.id"
                                            v-for="(user, index)
                                                in catalogue.users_profile"
                                            :key="index"
                                        >

                                            {{ user.name }}
                                            {{ user.last_name }}

                                        </option>

                                    </select>

                                </div>


                                <!-- FECHA -->

                                <div class="col-lg-4 col-md-6 mb-3">

                                    <label class="field-label">

                                        Fecha del adeudo

                                        <span class="required">
                                            *
                                        </span>

                                    </label>

                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="extraDue.due_date"
                                    >

                                </div>


                                <!-- DATOS FACTURACIÓN -->

                                <div class="col-lg-6 col-md-6 mb-3">

                                    <label class="field-label">

                                        Datos de facturación

                                    </label>

                                    <select
                                        class="form-control"
                                        v-model="extraDue.billing_data_id"
                                        :disabled="!extraDue.user_id"
                                    >

                                        <option value="">

                                            {{
                                                extraDue.user_id
                                                    ? 'Sin datos de facturación'
                                                    : 'Selecciona primero un cliente'
                                            }}

                                        </option>

                                        <option
                                            v-for="(billD, index)
                                                in catalogue.billing_data_user"
                                            :value="billD.id"
                                            :key="index"
                                        >

                                            {{ billD.business_name }}
                                            ·
                                            {{ billD.rfc }}

                                        </option>

                                    </select>

                                    <small
                                        class="field-help"
                                        v-if="extraDue.user_id"
                                    >
                                        Estos datos se utilizarán
                                        cuando se facture el adeudo.
                                    </small>

                                </div>


                                <!-- MONEDA -->

                                <div
                                    :class="
                                        extraDue.currency_id == 2
                                            ? 'col-lg-3 col-md-3 mb-3'
                                            : 'col-lg-6 col-md-6 mb-3'
                                    "
                                >

                                    <label class="field-label">
                                        Moneda
                                    </label>

                                    <select
                                        class="form-control"
                                        v-model="extraDue.currency_id"
                                    >

                                        <option
                                            :value="currency.id"
                                            v-for="(currency, index)
                                                in catalogue.currencies"
                                            :key="index"
                                        >

                                            {{ currency.name }}

                                        </option>

                                    </select>

                                </div>


                                <!-- TIPO DE CAMBIO -->

                                <div
                                    class="col-lg-3 col-md-3 mb-3"
                                    v-if="extraDue.currency_id == 2"
                                >

                                    <label class="field-label">

                                        Tipo de cambio

                                        <span class="required">
                                            *
                                        </span>

                                    </label>

                                    <money
                                        class="form-control"
                                        v-model="
                                            extraDue.exchange_rate_pay
                                        "
                                    >
                                    </money>

                                </div>


                                <!-- DESCRIPCIÓN -->

                                <div class="col-md-12">

                                    <label class="field-label">

                                        Descripción general

                                    </label>

                                    <textarea
                                        class="form-control"
                                        rows="2"
                                        maxlength="500"
                                        v-model="
                                            extraDue.description
                                        "
                                        placeholder="Ej. Servicios extraordinarios correspondientes a septiembre"
                                    >
                                    </textarea>

                                </div>


                            </div>

                        </div>

                    </div>



                    <!-- ================================
                         PASO 2 - CONCEPTOS
                    ================================= -->

                    <div class="section-card">

                        <div class="section-heading">

                            <div class="step-number">
                                2
                            </div>

                            <div>

                                <h6>
                                    Conceptos del adeudo
                                </h6>

                                <small>
                                    Captura los conceptos y selecciona
                                    los impuestos que correspondan.
                                </small>

                            </div>

                            <div class="section-badge">

                                {{ services.length }}

                                {{
                                    services.length === 1
                                        ? 'concepto'
                                        : 'conceptos'
                                }}

                            </div>

                        </div>


                        <div class="section-body concepts-body">


                            <!-- CONCEPTO -->

                            <div
                                class="concept-row"
                                v-for="(service, index)
                                    in services"
                                :key="index"
                            >


                                <!-- HEADER CONCEPTO -->

                                <div class="concept-header">

                                    <div class="concept-title">

                                        <div class="concept-icon">
                                            <i
                                                class="fas fa-file-alt"
                                            ></i>
                                        </div>

                                        <div>

                                            <strong>
                                                Concepto
                                                {{ index + 1 }}
                                            </strong>

                                            <small>
                                                Captura importe e impuestos.
                                            </small>

                                        </div>

                                    </div>


                                    <button
                                        v-if="index != 0"
                                        type="button"
                                        class="btn-delete-concept"
                                        @click="
                                            deleteService(index)
                                        "
                                        title="Eliminar concepto"
                                    >

                                        <i class="fas fa-trash"></i>

                                    </button>

                                </div>



                                <!-- DATOS -->

                                <div class="row">

                                    <div
                                        class="col-lg-8 col-md-7 mb-3"
                                    >

                                        <label class="field-label">

                                            Descripción

                                            <span class="required">
                                                *
                                            </span>

                                        </label>

                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="
                                                service.description
                                            "
                                            placeholder="Ej. Mantenimiento, reparación, limpieza..."
                                        >

                                    </div>


                                    <div
                                        class="col-lg-4 col-md-5 mb-3"
                                    >

                                        <label class="field-label">

                                            Importe

                                            <span class="required">
                                                *
                                            </span>

                                        </label>


                                        <div class="money-input">                                           
                                            <money
                                                class="form-control"
                                                v-model="
                                                    service.base_amount
                                                "
                                            >
                                            </money>

                                        </div>

                                    </div>

                                </div>



                                <!-- IMPUESTOS -->

                                <div class="tax-title">

                                    Impuestos y retenciones

                                </div>


                                <div class="tax-grid">


                                    <!-- IVA -->

                                    <label
                                        class="tax-card"
                                        :class="{
                                            selected: service.iva
                                        }"
                                    >

                                        <div class="tax-check">

                                            <input
                                                type="checkbox"
                                                v-model="
                                                    service.iva
                                                "
                                            >

                                            <span>
                                                <i
                                                    class="fas fa-check"
                                                ></i>
                                            </span>

                                        </div>

                                        <div>

                                            <strong>
                                                IVA
                                            </strong>

                                            <small>
                                                Impuesto 16%
                                            </small>

                                        </div>

                                    </label>



                                    <!-- IEPS -->

                                    <label
                                        class="tax-card"
                                        :class="{
                                            selected: service.ieps
                                        }"
                                    >

                                        <div class="tax-check">

                                            <input
                                                type="checkbox"
                                                v-model="
                                                    service.ieps
                                                "
                                            >

                                            <span>
                                                <i
                                                    class="fas fa-check"
                                                ></i>
                                            </span>

                                        </div>

                                        <div>

                                            <strong>
                                                IEPS
                                            </strong>

                                            <small>
                                                Impuesto 8%
                                            </small>

                                        </div>

                                    </label>



                                    <!-- ISR -->

                                    <label
                                        class="tax-card"
                                        :class="{
                                            selected:
                                                service.isr_ret
                                        }"
                                    >

                                        <div class="tax-check">

                                            <input
                                                type="checkbox"
                                                v-model="
                                                    service.isr_ret
                                                "
                                            >

                                            <span>
                                                <i
                                                    class="fas fa-check"
                                                ></i>
                                            </span>

                                        </div>

                                        <div>

                                            <strong>
                                                ISR RET
                                            </strong>

                                            <small>
                                                Retención 10%
                                            </small>

                                        </div>

                                    </label>



                                    <!-- IVA RET -->

                                    <label
                                        class="tax-card"
                                        :class="{
                                            selected:
                                                service.iva_ret
                                        }"
                                    >

                                        <div class="tax-check">

                                            <input
                                                type="checkbox"
                                                v-model="
                                                    service.iva_ret
                                                "
                                            >

                                            <span>
                                                <i
                                                    class="fas fa-check"
                                                ></i>
                                            </span>

                                        </div>

                                        <div>

                                            <strong>
                                                IVA RET
                                            </strong>

                                            <small>
                                                Retención 10.666%
                                            </small>

                                        </div>

                                    </label>


                                </div>



                                <!-- MINI RESUMEN -->

                                <div class="concept-summary">

                                    <div>

                                        <span>
                                            Subtotal
                                        </span>

                                        <strong>

                                            {{
                                                calculateService(
                                                    service
                                                ).subtotal
                                                | toCurrency
                                            }}

                                        </strong>

                                    </div>


                                    <div v-if="service.iva">

                                        <span>
                                            IVA
                                        </span>

                                        <strong class="positive">

                                            +
                                            {{
                                                calculateService(
                                                    service
                                                ).iva
                                                | toCurrency
                                            }}

                                        </strong>

                                    </div>


                                    <div v-if="service.ieps">

                                        <span>
                                            IEPS
                                        </span>

                                        <strong class="positive">

                                            +
                                            {{
                                                calculateService(
                                                    service
                                                ).ieps
                                                | toCurrency
                                            }}

                                        </strong>

                                    </div>


                                    <div v-if="service.isr_ret">

                                        <span>
                                            ISR Ret.
                                        </span>

                                        <strong class="negative">

                                            -
                                            {{
                                                calculateService(
                                                    service
                                                ).isrRet
                                                | toCurrency
                                            }}

                                        </strong>

                                    </div>


                                    <div v-if="service.iva_ret">

                                        <span>
                                            IVA Ret.
                                        </span>

                                        <strong class="negative">

                                            -
                                            {{
                                                calculateService(
                                                    service
                                                ).ivaRet
                                                | toCurrency
                                            }}

                                        </strong>

                                    </div>


                                    <div class="concept-total">

                                        <span>
                                            Total
                                        </span>

                                        <strong>

                                            {{
                                                calculateService(
                                                    service
                                                ).total
                                                | toCurrency
                                            }}

                                        </strong>

                                    </div>

                                </div>


                            </div>



                            <!-- AGREGAR -->

                            <button
                                type="button"
                                class="add-concept"
                                @click="addService()"
                            >

                                <div class="add-icon">

                                    <i class="fas fa-plus"></i>

                                </div>

                                <div>

                                    <strong>
                                        Agregar concepto
                                    </strong>

                                    <small>
                                        Añade otro cargo al adeudo.
                                    </small>

                                </div>

                            </button>


                        </div>

                    </div>


                </div>



                <!-- ================================
                     SIDEBAR RESUMEN
                ================================= -->

                <aside class="extra-summary">


                    <div class="summary-card">


                        <div class="summary-header">

                            <div>

                                <small>
                                    Resumen del movimiento
                                </small>

                                <strong>
                                    Totales
                                </strong>

                            </div>

                            <i class="fas fa-calculator"></i>

                        </div>



                        <div class="summary-content">


                            <div class="summary-line">

                                <span>
                                    Subtotal
                                </span>

                                <strong>

                                    {{
                                        totals.subtotal
                                        | toCurrency
                                    }}

                                </strong>

                            </div>


                            <div
                                class="summary-line"
                                v-if="totals.iva"
                            >

                                <span>
                                    IVA
                                </span>

                                <strong class="positive">

                                    +
                                    {{
                                        totals.iva
                                        | toCurrency
                                    }}

                                </strong>

                            </div>


                            <div
                                class="summary-line"
                                v-if="totals.ieps"
                            >

                                <span>
                                    IEPS
                                </span>

                                <strong class="positive">

                                    +
                                    {{
                                        totals.ieps
                                        | toCurrency
                                    }}

                                </strong>

                            </div>


                            <div
                                class="summary-line"
                                v-if="totals.isrRet"
                            >

                                <span>
                                    ISR retenido
                                </span>

                                <strong class="negative">

                                    -
                                    {{
                                        totals.isrRet
                                        | toCurrency
                                    }}

                                </strong>

                            </div>


                            <div
                                class="summary-line"
                                v-if="totals.ivaRet"
                            >

                                <span>
                                    IVA retenido
                                </span>

                                <strong class="negative">

                                    -
                                    {{
                                        totals.ivaRet
                                        | toCurrency
                                    }}

                                </strong>

                            </div>


                            <div class="summary-total">

                                <span>
                                    Total adeudo
                                </span>

                                <strong>

                                    {{
                                        totals.total
                                        | toCurrency
                                    }}

                                </strong>

                            </div>


                            <div class="summary-meta">

                                <div>

                                    <span>
                                        Conceptos
                                    </span>

                                    <strong>
                                        {{ services.length }}
                                    </strong>

                                </div>


                                <div>

                                    <span>
                                        Moneda
                                    </span>

                                    <strong>

                                        {{
                                            extraDue.currency_id == 2
                                                ? 'USD'
                                                : 'MXN'
                                        }}

                                    </strong>

                                </div>

                            </div>


                        </div>

                    </div>



                    <div class="summary-info">

                        <i class="fas fa-info-circle"></i>

                        <span>
                            El total se calcula automáticamente
                            según los conceptos, impuestos y
                            retenciones seleccionados.
                        </span>

                    </div>


                </aside>


            </div>



            <!-- ================================
                 FOOTER FIJO
            ================================= -->

            <div class="extra-modal-footer">


                <button
                    type="button"
                    class="btn btn-light"
                    @click="closedModal()"
                    :disabled="send"
                >

                    Cancelar

                </button>


                <button
                    type="button"
                    class="btn btn-success save-button"
                    @click="saveAll()"
                    :disabled="send"
                >


                    <template v-if="send">

                        <i
                            class="fas fa-circle-notch fa-spin"
                        ></i>

                        Guardando...

                    </template>


                    <template v-else>

                        <i class="fas fa-save"></i>

                        {{
                            extraDue.id
                                ? 'Guardar cambios'
                                : 'Crear adeudo'
                        }}

                    </template>


                </button>


            </div>


        </div>

    </modal>

</template>


<style scoped>

.extra-due-modal {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f4f7fb;
}


/* =========================
   HEADER
========================= */

.extra-modal-header {
    min-height: 74px;
    padding: 14px 18px;

    display: flex;
    align-items: center;

    background: linear-gradient(
        135deg,
        #2f5185,
        #486ca4
    );

    color: #fff;
}


.header-icon {
    width: 40px;
    height: 40px;

    border-radius: 10px;

    background: rgba(255, 255, 255, .14);

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 12px;

    font-size: 17px;
}


.header-content {
    flex: 1;
}


.header-content h5 {
    margin: 0 0 2px;
    font-size: 16px;
    font-weight: 700;
}


.header-content small {
    color: rgba(255,255,255,.8);
}


.header-close {
    width: 34px;
    height: 34px;

    border: 0;
    border-radius: 50%;

    color: #fff;

    background: rgba(255,255,255,.15);

    cursor: pointer;
}



/* =========================
   CONTENT
========================= */

.extra-modal-content {
    flex: 1;
    min-height: 0;

    overflow-y: auto;

    display: grid;

    grid-template-columns:
        minmax(0, 1fr)
        285px;

    gap: 16px;

    padding: 18px;
}


.extra-main {
    min-width: 0;
}



/* =========================
   SECTION
========================= */

.section-card {
    border: 1px solid #dce3ed;
    border-radius: 10px;

    background: #fff;

    margin-bottom: 16px;

    box-shadow:
        0 2px 8px rgba(31, 51, 73, .04);
}


.section-heading {
    display: flex;
    align-items: center;

    gap: 10px;

    padding: 16px;

    border-bottom: 1px solid #e7ebf0;
}


.step-number {
    width: 28px;
    height: 28px;

    flex: 0 0 28px;

    border-radius: 50%;

    background: #edf3fb;

    color: #345b92;

    font-weight: 700;

    display: flex;
    align-items: center;
    justify-content: center;
}


.section-heading h6 {
    margin: 0;

    font-size: 14px;
    font-weight: 700;
}


.section-heading small {
    display: block;

    margin-top: 2px;

    color: #7b8797;
}


.section-badge {
    margin-left: auto;

    padding: 5px 10px;

    border-radius: 20px;

    background: #edf3fb;

    color: #476891;

    font-size: 11px;
    font-weight: 600;
}


.section-body {
    padding: 16px;
}


.concepts-body {
    padding: 0;
}



/* =========================
   FORM
========================= */

.field-label {
    display: block;

    margin-bottom: 6px;

    font-size: 12px;
    font-weight: 600;

    color: #293241;
}


.required {
    color: #dc3545;
}


.field-help {
    display: block;

    margin-top: 5px;

    color: #8a96a5;

    font-size: 11px;
}


.form-control {
    min-height: 38px;

    border-color: #d7dee8;

    border-radius: 6px;
}


.form-control:focus {
    border-color: #7897c3;

    box-shadow:
        0 0 0 3px rgba(75, 112, 166, .10);
}



/* =========================
   CONCEPT
========================= */

.concept-row {
    padding: 16px;

    border-bottom: 1px solid #e5eaf0;
}


.concept-row:last-of-type {
    border-bottom: 0;
}


.concept-header {
    display: flex;

    justify-content: space-between;
    align-items: center;

    margin-bottom: 14px;
}


.concept-title {
    display: flex;
    align-items: center;

    gap: 10px;
}


.concept-icon {
    width: 34px;
    height: 34px;

    border-radius: 8px;

    background: #edf3fb;

    color: #4e72a7;

    display: flex;
    align-items: center;
    justify-content: center;
}


.concept-title strong {
    display: block;

    font-size: 13px;
}


.concept-title small {
    display: block;

    color: #7e8998;

    font-size: 11px;
}


.btn-delete-concept {
    width: 32px;
    height: 32px;

    border: 0;

    background: #fff0f1;

    color: #d9534f;

    border-radius: 6px;

    cursor: pointer;
}


.money-input {
    position: relative;
}


.money-input > span {
    position: absolute;

    left: 12px;
    top: 50%;

    transform: translateY(-50%);

    z-index: 2;

    color: #727d8a;

    font-weight: 600;
}


.money-input .form-control {
    padding-left: 28px;
}



/* =========================
   TAX
========================= */

.tax-title {
    margin: 2px 0 9px;

    font-size: 11px;
    font-weight: 700;

    color: #6e7a88;

    text-transform: uppercase;
}


.tax-grid {
    display: grid;

    grid-template-columns:
        repeat(4, minmax(0, 1fr));

    gap: 8px;
}


.tax-card {
    min-height: 62px;

    padding: 10px;

    margin: 0;

    display: flex;
    align-items: center;

    gap: 10px;

    border: 1px solid #dce3ec;
    border-radius: 7px;

    cursor: pointer;

    background: #fff;

    transition: .15s;
}


.tax-card:hover {
    border-color: #8aa3c7;
}


.tax-card.selected {
    border-color: #5278ad;

    background: #f1f6fc;
}


.tax-card strong {
    display: block;

    font-size: 12px;
}


.tax-card small {
    display: block;

    font-size: 10px;

    color: #7c8896;
}


.tax-check {
    position: relative;

    width: 22px;
    height: 22px;

    flex: 0 0 22px;
}


.tax-check input {
    position: absolute;

    opacity: 0;
}


.tax-check span {
    width: 22px;
    height: 22px;

    border: 1px solid #bfc8d5;
    border-radius: 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: transparent;

    background: #fff;
}


.tax-card.selected .tax-check span {
    color: #fff;

    background: #4771ab;

    border-color: #4771ab;
}



/* =========================
   CONCEPT SUMMARY
========================= */

.concept-summary {
    display: flex;

    margin-top: 14px;

    background: #f8fafc;

    border-radius: 7px;

    overflow-x: auto;
}


.concept-summary > div {
    flex: 1;

    min-width: 110px;

    padding: 9px 12px;

    border-right: 1px solid #e6ebf0;
}


.concept-summary > div:last-child {
    border-right: 0;
}


.concept-summary span,
.concept-summary strong {
    display: block;
}


.concept-summary span {
    color: #7b8794;

    font-size: 10px;
}


.concept-summary strong {
    margin-top: 2px;

    font-size: 12px;
}


.concept-total {
    background: #edf3fa;
}


.positive {
    color: #198754;
}


.negative {
    color: #c57600;
}



/* =========================
   ADD
========================= */

.add-concept {
    width: calc(100% - 32px);

    margin: 16px;

    padding: 12px;

    border: 1px dashed #aebdce;
    border-radius: 8px;

    background: #fafcff;

    color: #466b9e;

    display: flex;
    align-items: center;
    justify-content: center;

    gap: 9px;

    cursor: pointer;
}


.add-icon {
    width: 27px;
    height: 27px;

    border-radius: 50%;

    background: #e6eef9;

    display: flex;
    align-items: center;
    justify-content: center;
}


.add-concept strong,
.add-concept small {
    display: block;

    text-align: left;
}


.add-concept small {
    color: #8490a0;

    font-size: 10px;
}



/* =========================
   SUMMARY SIDEBAR
========================= */

.extra-summary {
    position: sticky;

    top: 0;

    align-self: start;
}


.summary-card {
    overflow: hidden;

    border: 1px solid #dce3ed;
    border-radius: 10px;

    background: #fff;

    box-shadow:
        0 2px 8px rgba(31,51,73,.05);
}


.summary-header {
    padding: 14px;

    display: flex;

    justify-content: space-between;

    background: #335787;

    color: #fff;
}


.summary-header small,
.summary-header strong {
    display: block;
}


.summary-header small {
    font-size: 9px;

    opacity: .8;
}


.summary-header strong {
    margin-top: 2px;

    font-size: 14px;
}


.summary-content {
    padding: 0;
}


.summary-line {
    padding: 11px 13px;

    display: flex;
    justify-content: space-between;

    border-bottom: 1px solid #eef1f5;

    font-size: 11px;
}


.summary-total {
    padding: 14px 13px;

    display: flex;
    justify-content: space-between;

    background: #edf3fa;

    color: #284d7b;
}


.summary-total strong {
    font-size: 16px;
}


.summary-meta {
    padding: 12px 13px;

    display: grid;

    grid-template-columns: 1fr 1fr;

    gap: 8px;
}


.summary-meta > div {
    padding: 8px;

    border-radius: 6px;

    background: #f8fafc;
}


.summary-meta span,
.summary-meta strong {
    display: block;
}


.summary-meta span {
    color: #8290a0;

    font-size: 9px;
}


.summary-meta strong {
    margin-top: 2px;

    font-size: 12px;
}


.summary-info {
    margin-top: 10px;

    padding: 11px;

    display: flex;

    gap: 8px;

    border: 1px solid #cfe0f4;
    border-radius: 8px;

    background: #edf6ff;

    color: #486b93;

    font-size: 10px;
}



/* =========================
   FOOTER
========================= */

.extra-modal-footer {
    min-height: 66px;

    padding: 12px 18px;

    background: #fff;

    border-top: 1px solid #dfe5ec;

    display: flex;

    align-items: center;
    justify-content: flex-end;

    gap: 10px;
}


.extra-modal-footer .btn {
    min-width: 115px;
}


.save-button {
    min-width: 155px !important;
}



/* =========================
   LOADING
========================= */

.loading-container {
    flex: 1;

    display: flex;
    flex-direction: column;

    gap: 12px;

    align-items: center;
    justify-content: center;
}



/* =========================
   RESPONSIVE
========================= */

@media (max-width: 991px) {

    .extra-modal-content {
        grid-template-columns: 1fr;
    }


    .extra-summary {
        position: static;
    }


    .tax-grid {
        grid-template-columns:
            repeat(2, minmax(0, 1fr));
    }

}


@media (max-width: 575px) {

    .extra-modal-content {
        padding: 10px;
    }


    .section-body,
    .concept-row {
        padding: 12px;
    }


    .tax-grid {
        grid-template-columns: 1fr;
    }


    .concept-summary {
        display: grid;

        grid-template-columns:
            repeat(2, 1fr);
    }


    .extra-modal-footer {
        padding: 10px;

        justify-content: stretch;
    }


    .extra-modal-footer .btn {
        flex: 1;
    }

}

</style>